import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsAccountPaymentFavoriteModule } from '@wlp/ui-bs-account-payment-favorite';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCEditFavoriteModule } from '@wlp/ui-c-edit-favorite';
import { UiCFavoritesListModule } from '@wlp/ui-c-favorites-list';
import { HeaderUserInfoModule } from '@wlp/ui-c-header-user-info';
import { UiCOtherAccountModule } from '@wlp/ui-c-other-account';
import { UiCPersonalAddressModule } from '@wlp/ui-c-personal-address';
import { UiCTransferValueModule } from '@wlp/ui-c-transfer-value';
import { ComponentsModule } from 'src/app/core/shared/modules/components.module';
import { environment } from 'src/environments/environment';

import { InterceptService } from '../../../../../../../../core/intercept/intercept.service';
import { FavoritesChargingPage } from './favorites-charging/favorites-charging.page';
import { FavoritesRoutingModule } from './favorites-routing.module';
import { FavoritesTransferPage } from './favorites-transfer/favorites-transfer.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UiCOtherAccountModule,
    ComponentsModule,
    UiCTransferValueModule,
    HeaderUserInfoModule,
    IonicModule,
    UiBsTranslateModule.forRoot({ device: 'WEB', config: environment }),
    FavoritesRoutingModule,
    UiBsAccountPaymentFavoriteModule,
    UiCEditFavoriteModule,
    UiCFavoritesListModule,
    UiCPersonalAddressModule,
  ],
  declarations: [
    FavoritesChargingPage,
    FavoritesTransferPage,
  ],
  exports: [FavoritesTransferPage],
  providers: [
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ],
})
export class FavoritesModule { }
